<template>
  <v-card width="100%" class="ma-0 pa-0">

      <v-card width="100%" class="ma-0 pa-2 d-none" outlined>

          <v-slide-group
                  v-model="model"
                  multiple
                  show-arrows>
              <v-slide-item v-for="n in folders" :key="n.uid">
                  <v-card
                          v-if="n.name != 'add'"
                          width="150px"
                          class="ml-2"
                          elevation="0">
                      <v-sheet outlined :color="isSelectedFolder(n.uid) ? 'transparent' :'gray'"  rounded>
                          <v-card
                                  class="d-flex align-center justify-center ma-0 pa-0"
                                  :class="!isSelectedFolder(n.uid) ? 'black--text':'white--text'"
                                  elevation="0"
                                  :color="isSelectedFolder(n.uid) ? 'blue': 'white'" outlined>
                              {{n.name}}
                          </v-card>
                      </v-sheet>
                      <v-card elevation="0" class="d-flex align-top pl-1 pr-1 mt-1" outlined>
                          <v-checkbox
                                  v-model="selectedFolder[n.uid]"
                                  style="margin-top: 2px!important;"
                                  dense
                                  class="ma-0 pa-0"
                                  v-on:change="filterMedia()"
                                  hide-details
                          ></v-checkbox>
                          <v-spacer></v-spacer>
                          <v-btn icon color="green" elevation="0" small>
                            <v-icon small>mdi-pencil</v-icon>
                          </v-btn>
                      </v-card>


                 </v-card>
                  <v-card v-else
                          color="green"
                          width="40px"
                          class="d-flex align-center justify-center ml-2"
                          elevation="0">
                      <v-btn icon color="white" elevation="0">
                          <v-icon>mdi-plus</v-icon>
                      </v-btn>
                  </v-card>
              </v-slide-item>
          </v-slide-group>

        </v-card>

      <v-card width="100%" class="ma-0 pa-2 mt-2" outlined>
              <v-card-actions class="ma-0 pa-0">
                <v-data-table
                    style="width: 100%;"
                    fixed-header
                    :items="configs"
                    :headers="headers"
                    hide-default-footer
                    disable-pagination
                    show-group-by>
                  <template v-slot:item.group="{ item }">
                    <v-btn outlined @click="onPressName(item)" small class="orange--text subtitle-2" :disabled="!ifCanEditNameConfig()">{{ item.group }}*</v-btn>
                  </template>
                  <template v-slot:item.marker="{ item }">
                    <v-btn outlined @click="onPressMarker(item)" small class="orange--text subtitle-2">{{ item.marker }}</v-btn>
                  </template>
                  <template v-slot:item.meta.updated="{ item }">
                    {{ getUpdated(item) | formatDate }}
                  </template>
                  <template v-slot:item.meta.uid="{ item }">
                    <v-card-text class="blue--text subtitle-2 ma-0 pa-0">{{ getOwner(item) }}</v-card-text>
                  </template>
                  <template v-slot:item.actions="{ item }" style="background-color: red">
                    <v-tooltip bottom max-width="50%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon
                               color="orange"
                               v-bind="attrs"
                               v-on="on"
                               class="ma-0 pa-0"
                               @click="onPressInfo(item)">
                          <v-icon size="22">mdi-information</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ item.info?.length > 0 ? item.info : "no info" }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn :disabled="!ifCanEditConfig()"
                               icon
                               color="green"
                               v-bind="attrs"
                               v-on="on"
                               class="mr-0 ma-0 pa-0"
                               @click="onPressEdit(item)">
                          <v-icon size="20">mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn :disabled="!ifCanDeleteConfig()"
                               icon
                               color="red"
                               v-bind="attrs"
                               v-on="on"
                               class="mr-0 ma-0 pa-0"
                               @click="onPressDelete(item)">
                          <v-icon size="20">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn :disabled="!ifCanDublicateConfig()"
                               icon
                               color="teal lighten-1"
                               v-bind="attrs"
                               v-on="on"
                               class="mr-1 ma-0 pa-0"
                               @click="onPressDuplicate(item)">
                          <v-icon size="22">mdi-content-copy</v-icon>
                        </v-btn>
                      </template>
                      <span>Dublicate</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            color="blue"
                            v-bind="attrs"
                            v-on="on"
                            class="mr-1 ma-0 pa-0"
                            disabled
                            @click="onPressMergeAndDeploy(item)">
                          <v-icon size="22">mdi-merge</v-icon>
                        </v-btn>
                      </template>
                      <span>Merge and deploy</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon
                               color="blue"
                               v-bind="attrs"
                               v-on="on"
                               class="mr-0 ma-0 pa-0"
                               @click="onPressExportItem(item)">
                          <v-icon size="20">mdi-download</v-icon>
                        </v-btn>
                      </template>
                      <span>Export to Json</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon
                               color="blue"
                               v-bind="attrs"
                               v-on="on"
                               class="mr-0 ma-0 pa-0"
                               @click="onPressImportItem(item)">
                          <v-icon size="20">mdi-upload</v-icon>
                        </v-btn>
                      </template>
                      <span>Import a config.json</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-actions>
      </v-card>

  </v-card>
</template>

<script>

import {ConfigStoreUtils} from "@/modules/mconfigs/database/ConfigStoreUtils";
import {ConfigModel} from "@/modules/mconfigs/models/ConfigModel";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import {FolderModel} from "@/modules/mconfigs/models/FolderModel";
import {TimeUtils} from "@/common/TimeUtils";

export default {
  name: "c-l-table",
  components: {},
  data: () => ({
      model: null,
      selectedFolder: {},
    headers: [
      {text: 'Name', sortable: true, groupable: false, value: 'group', class: "white blue--text", color: "red"},
      {text: 'Id', sortable: true, groupable: false, value: 'uid', class: "white blue--text"},
      {text: 'Map Id', sortable: true, value: 'mapId', class: "white blue--text"},
      {text: 'Marker', sortable: true, value: 'marker', class: "white blue--text"},
      {text: 'Owner', sortable: true, groupable: false, value: 'meta.uid', class: "white blue--text"},
      {text: 'Updated', sortable: true, groupable: false, value: 'meta.updated', class: "white blue--text"},
      {text: 'Actions', sortable: false, groupable: false, value: 'actions', width: '230px', class: "white blue--text"}
    ],
  }),
  methods: {
      isSelectedFolder(uid){
          return this.selectedFolder[uid];
      },
      filterMedia(){
          console.log(this.selectedFolder)
      },
    getOwner(config) {
      if (config.meta == null) {
        return "no metadata"
      }
      return PermissionsStoreUtils.getUserName(config.meta.uid)
    },
    getMyUserUid() {
      return PermissionsStoreUtils.getMyUserUid();
    },
    ifCanEditConfig() {
      return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.CONFIG_TAB.subpermissions.CONFIG_TAB_MC_EDIT.id)
    },
    ifCanDeleteConfig() {
      return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.CONFIG_TAB.subpermissions.CONFIG_TAB_MC_DELETE.id)
    },
    ifCanDublicateConfig() {
      return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.CONFIG_TAB.subpermissions.CONFIG_TAB_MC_DUBLICATE.id)
    },
    ifCanDeployConfig() {
      return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.CONFIG_TAB.subpermissions.CONFIG_TAB_MC_DEPLOY.id)
    },
    ifCanEditNameConfig() {
      return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.CONFIG_TAB.subpermissions.CONFIG_TAB_MC_EDIT_NAME.id)
    },
    ifCanSetInfo() {
      return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.CONFIG_TAB.subpermissions.CONFIG_TAB_MY_SET_INFO.id)
    },
    onPressName(item) {
      this.$emit('show-c-edit-name', item)
    },
    onPressMarker(item) {
      this.$emit('show-c-edit-marker', item)
    },

    onPressMergeAndDeploy(startItem) {
      this.$emit('show-config-merge-popup', startItem)
    },
    onPressInfo(item) {
      if (!this.ifCanSetInfo()) {
        this.$notify({title: 'No permissions', text: "", type: "error"});
        return
      }
      this.$emit('show-configs-popup-edit-info', item)
    },
    getUpdated(item) {
      if (item.meta == null) {
        return "no metadata"
      }
      return item.meta.updated
    },
    onPressDelete(item) {
      this.$confirm("Are you sure?").then(() => {
        ConfigStoreUtils.deleteConfig(item.uid).then(() => {
          this.$notify({title: 'Config successfully deleted!', text: "", type: "success"});
        }).catch((error) => {
          this.$notify({title: 'Config delete failed!', text: error, type: "error"});
        })
      }).catch(() => {
      })
    },
    onPressEdit(item) {
      ConfigStoreUtils.updateMetadata(item.uid);
      this.$router.push({name: "m-redactor", params: {uid: item.uid, path: "configs_data/", readonly: false, name: item.group}});
    },
    onPressDuplicate(item) {
      ConfigStoreUtils.getConfigData("configs_data/" + item.uid)
          .then((data) => {
            let config = new ConfigModel(item.group + "_copy", item.mapId)
            ConfigStoreUtils.pushConfig(config, data)
                .then(() => {
                  this.$notify({title: 'Config successfully duplicated!', type: "success"});
                }).catch((error) => {
              this.$notify({title: 'Config duplicate failed!', text: error, type: "error"});
            })
          })
          .catch((error) => {
            this.$notify({title: 'Fail to get data for:' + item.uid, text: error, type: "error"});
          })
    },
    onPressExportItem(item) {
        ConfigStoreUtils.getConfigData("configs_data/" + item.uid)
            .then((data) => {
              const fileData = JSON.stringify(data, null, 2);
              const blob = new Blob([fileData], {type: "text/plain;charset=utf-8"});
              let fs = require('file-saver');
              fs.saveAs(blob, "config_" + TimeUtils.now() + ".json");
            })
            .catch((error) => {
              this.$notify({title: 'Fail to get data for:' + item.uid, text: error, type: "error"});
            })
    },
    onPressImportItem(item) {
        ConfigStoreUtils.getConfigData("configs_data/" + item.uid)
            .then((data) => {
              this.$emit('show-c-import-config-popup', item, data);
            })
            .catch((error) => {
              this.$notify({title: 'Fail to get data for:' + item.uid, text: error, type: "error"});
            })
    }
  },
  computed: {
        configs() {
          return ConfigStoreUtils.getConfigs();
        },
        folders() {
            let folders = [...ConfigStoreUtils.getFolders()];
            folders.push(new FolderModel("add"));
            return folders;
        }
  }
}
</script>

<style scoped>
.v-btn {
  text-transform: none !important;
}
</style>